/* eslint-disable */
import { makeStyles } from '@rentacenter/racstrap';

export const VerificationStyles = () => {
  const useClasses = makeStyles((theme) => ({
    mb15px: { marginBottom: '15px' },
    buttonBorderColor: {
      border: '1px solid #0f99d6'
    },
    blackFont: {
      color: 'black'
    },
    font16px: {
      fontSize: '16px'
    },
    w91p: {
      width: '95%'
    },
    centerAlign: {
      textAlign: 'center',
    },
    formLabel: {
      marginBottom: '0.2rem',
      color: '#000',
      fontFamily: 'OpenSans-semibold',
      fontSize: theme.typography.pxToRem(14),
    },
    mt10px: {
      marginTop: '10px'
    },
    mt20px: {
      marginTop: '20px'
    },
    pb4: {
      paddingBottom: theme.typography.pxToRem(24),
    },
    mx1: {
      marginRight: theme.typography.pxToRem(4),
      marginLeft: theme.typography.pxToRem(4),
    },
  }))
  return useClasses()
}